import { useDocumentTitle } from '@ab-inbev-labs/ux-react-components';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import { QueryClientConfigurer } from '../QueryClientConfig';
import { LayoutWithLoader } from './LayoutWithLoader';
import { AdditionalAppBarSettingsContent } from '@ab-inbev/sam-layout';

type RootProps = {
  contentClassName?: string;
  additionalAppBarSettings?: AdditionalAppBarSettingsContent;
};

export const Root: FC<RootProps> = ({ contentClassName, additionalAppBarSettings }) => {
  const { t } = useTranslation();
  useDocumentTitle({ title: `ABI Supply | ${t('appName')}` });

  // Wrap everything with Layout
  return (
    <LayoutWithLoader contentClassName={contentClassName} additionalAppBarSettings={additionalAppBarSettings}>
      {/* Configure query client here, as it is the highest place in the app under the Layout */}
      <QueryClientConfigurer />
      <Outlet />
    </LayoutWithLoader>
  );
};
